<template>
  <div class="tab-content tab-view-grid">
    <grid
      ref="grid"
      :config="gridConfig"
      @handleCustomButtonGrid="onSendEmail"
    ></grid>
    <editor
      :companyID="companyID"
      :disabled="!isAvailableToEdit"
      :config="{id: gridConfig.id, api: 'Contacts/Get/'}"/>
    <dialog-email
      ref="dialogEmail"
      :data="dataEmail"
      @on-submit-email="onSubmitEmail"
    />
  </div>
</template>

<script>
import Tab from './../Tab'
import gridConfig from './GridConfig.json'
import { waitValue } from '@/utils/promises'
import { ServiceEmailMessages } from '@/services/email-messages'

export default {
  name: 'TabContacts',
  mixins: [Tab],
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'editor': () => import(/* webpackChunkName: 'Companies' */ './Editor'),
    'dialog-email': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogEmail/index')
  },
  data () {
    return {
      gridConfig: gridConfig,
      dataEmail: {}
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs['grid'])
    },
    // Mixin Tabs
    handleChangeCompanyID (companyID) {
      this.getGrid()
        .then((grid) => {
          if (!companyID) return
          grid.setFilters(`companyID == ${companyID}`)
          grid.loadData()
        })
    },
    onSendEmail ({ row }) {
      this.setDialogEmailData(row)
      this.$refs.dialogEmail.show()
    },
    onSubmitEmail (data) {
      return ServiceEmailMessages.send(data)
        .then(this.requestSuccessHandler)
        .catch(this.requestErrorHandler)
        .finally(() => {
          this.$refs.dialogEmail.hide()
        })
    },
    setDialogEmailData (data) {
      let emailToList = []
      data.email && emailToList.push(data.email)
      this.dataEmail = {
        emailToList,
        subject: this.L10n('subject-to-contact')
      }
    }
  }
}
</script>

<style lang="stylus">
</style>
